import { render } from "./Dashboard.vue?vue&type=template&id=63c3d822"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=63c3d822&lang=less"

import exportComponent from "C:\\Users\\sander\\IdeaProjects\\matchmaking\\fbm-matchmaking\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__